import type {
  TicketReservationStatusType,
  GameWithTimeStamp,
  TicketReservation,
  UserData,
} from "../common/types";
import moment from "moment";

const registrationDaysOpening = 8;
const registrationEndMinutes = 15;

const getTicketReservationStatus: TicketReservationStatusType = (
  game: GameWithTimeStamp
) => {
  const today = moment();

  // registration ends 15 minutes before a game
  const registrationEnd = moment(game.date).subtract(
    registrationEndMinutes,
    "minutes"
  );


  if (today.isAfter(registrationEnd)) {
    return "CLOSED";
  }

  if (
    moment(game.date).startOf('day').subtract(registrationDaysOpening, "days").isBefore(today)
  ) {
    return "OPEN";
  }

  return "SCHEDULED";
};

const hasTicketReservation = (userData: UserData, gameId: string) =>
  userData != null &&
  userData.gameIdsWithTicketReservations != null &&
  userData.gameIdsWithTicketReservations.includes(gameId);

const getTicketReservationStartDate: string = (game: GameWithTimeStamp) =>
  moment(game.date).startOf('day').subtract(registrationDaysOpening, "days").toISOString();

const getAmountOfTickets: number = (ticketReservation: TicketReservation) =>
  ticketReservation.companionIds.length + 1;

const getTicketWording = (ticketReservation: TicketReservation) => {
  const {amount} = ticketReservation;
  if(amount === 1) {
    return '1 Ticket';
  }
  return `${amount} Tickets`
}

const ticketReservationSelectors = {
  registrationDaysOpening,
  registrationEndMinutes,
  getTicketReservationStatus,
  getTicketReservationStartDate,
  getAmountOfTickets,
  hasTicketReservation,
  getTicketWording,
};

export default ticketReservationSelectors;
